import { Currency } from '@synergy/models';
import { FormattedNumberParts } from 'react-intl';
import { ReactElement } from 'react';

export const PoolCurrencySymbol = (props: { currency: Currency }): ReactElement => (
    <FormattedNumberParts value={0} currency={props.currency} currencyDisplay="symbol" style="currency">
        {parts => {
            const currencyPart = parts.find(part => part.type === 'currency')?.value;
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return currencyPart ? <>{currencyPart}</> : null;
        }}
    </FormattedNumberParts>
);
